import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { SITE } from "@/config/site";
import { Reveal, ChapterTag } from "./Reveal";

export const LocationSection = () => (
  <section id="ubicacion" data-testid="location-section" className="py-24 sm:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <ChapterTag num="04" label="Ubicación" />
        <h2 className="font-display font-extrabold tracking-tight text-brand-ink text-3xl sm:text-4xl lg:text-5xl mt-5">
          Tu trastero en Guadalajara, cerca de ti.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch">
        <Reveal className="lg:col-span-3">
          <div className="rounded-3xl overflow-hidden border border-brand-ink/10 shadow-[0_12px_40px_rgba(18,19,22,0.08)] h-full min-h-[320px]">
            <iframe
              title="Mapa de OtraRoom Trasteros en Guadalajara"
              data-testid="location-map"
              src={SITE.mapsEmbed}
              className="w-full h-full min-h-[320px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-2">
          <div className="bg-brand-ink text-white rounded-3xl p-8 sm:p-10 h-full flex flex-col">
            <div className="inline-flex items-center gap-2 self-start bg-brand-yellow text-brand-ink font-display font-extrabold text-[13px] tracking-wide px-4 py-2 rounded-full">
              <MapPin size={16} strokeWidth={2.4} />
              En pleno Guadalajara
            </div>

            <dl className="mt-9 space-y-7 flex-1">
              <div className="flex gap-4">
                <MapPin size={22} className="text-brand-yellow shrink-0 mt-0.5" />
                <div>
                  <dt className="font-mono text-[11px] font-bold tracking-[0.25em] text-white/50 uppercase">Dirección</dt>
                  <dd data-testid="location-address" className="mt-1 font-semibold text-lg">{SITE.address} · {SITE.city}</dd>
                </div>
              </div>
              <div className="flex gap-4">
                <Clock size={22} className="text-brand-yellow shrink-0 mt-0.5" />
                <div>
                  <dt className="font-mono text-[11px] font-bold tracking-[0.25em] text-white/50 uppercase">Horario de acceso</dt>
                  <dd data-testid="location-hours" className="mt-1 text-white/85">{SITE.hours}</dd>
                </div>
              </div>
              <div className="flex gap-4">
                <Phone size={22} className="text-brand-yellow shrink-0 mt-0.5" />
                <div>
                  <dt className="font-mono text-[11px] font-bold tracking-[0.25em] text-white/50 uppercase">Teléfono</dt>
                  <dd className="mt-1">
                    <a data-testid="location-phone-link" href={SITE.phoneHref} className="font-semibold text-lg hover:text-brand-yellow transition-colors">
                      {SITE.phoneDisplay}
                    </a>
                  </dd>
                </div>
              </div>
            </dl>

            <a
              data-testid="location-directions-button"
              href={SITE.mapsDirections}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 inline-flex items-center justify-center gap-2 bg-brand-yellow text-brand-ink font-display font-extrabold tracking-wide px-7 py-4 rounded-full hover:bg-brand-yellowhover transition-colors duration-200"
            >
              <Navigation size={17} strokeWidth={2.4} />
              CÓMO LLEGAR
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
